module.exports = __webpack_public_path__ + "static/media/c7bannerModul3_small.9e833bce.jpg";